import React, { useState } from 'react';
import { Button, Col, Row, Container, Alert } from 'react-bootstrap';
import { useQuery } from '@apollo/client';
import ErrorPage from '@website/components/utilities/ErrorPage';
import LoadingPage from '@website/components/utilities/LoadingPage';
import { EditGroupsTableDocument } from '@website/types/graphqlOperations';
import AddOrEditGroupItemForm from './AddOrEditGroupItemForm';
import GroupRow from './GroupRow';

/**
 * Edit groups table header
 */
export function EditGroupsTableHeader() {
  return (
    <Row className="fw-bold border-bottom d-none d-md-flex">
      <Col className="p-1" xs={12} md={2}>
        Dates
      </Col>
      <Col className="p-1" xs={12} md={1}>
        Days
      </Col>
      <Col className="p-1" xs={12} md={2}>
        Spaces
      </Col>
      <Col className="p-1" xs={12} md={3}>
        Amount You Receive
      </Col>
      <Col className="p-1" xs={12} md={1}>
        Private
      </Col>
      <Col title="Users on the wait list" className="p-1" xs={12} md={1}>
        Waitlist
      </Col>
    </Row>
  );
}

/**
 * EditGroupsTable
 */
export default function EditGroupsTable({ tripID }: { tripID: string }) {
  const [isAddingItem, setIsAddingItem] = useState(false);

  // Get data
  const { data, loading, error } = useQuery(EditGroupsTableDocument, {
    variables: { tripID },
    fetchPolicy: 'cache-and-network',
  });

  if (loading) return <LoadingPage />;
  if (error) return <ErrorPage error={error} />;

  const { host } = data.trip;
  const groups = data.trip.groups.items;
  const commissions = data.trip.commissionOverrides;
  const trip = {
    id: data.trip.id,
    startTimezone: data.trip.startTimezone,
    endTimezone: data.trip.endTimezone,
  };

  return (
    <>
      <Container>
        <Alert variant="success">
          <strong>Adding groups guidelines</strong>
          <ul>
            <li>Customer prices must be no more than booking directly.</li>
            <li>
              Dates must be guaranteed - this results in many more bookings for
              you!
            </li>
          </ul>
        </Alert>

        <EditGroupsTableHeader />
        {groups?.map((group, key) => (
          <GroupRow
            group={group}
            key={group.id || key}
            position={key}
            commissions={commissions}
            host={host}
            trip={trip}
          />
        ))}
        {isAddingItem && (
          <AddOrEditGroupItemForm
            commissions={commissions}
            host={host}
            position={groups.length}
            trip={trip}
            onHide={() => setIsAddingItem(false)}
            existingGroups={groups}
          />
        )}
      </Container>
      {!isAddingItem && (
        <div className="d-grid gap-2 mt-2 pt-1">
          <Button
            variant="success"
            onClick={() => setIsAddingItem(true)}
            className="mt-2"
          >
            + Add group
          </Button>
        </div>
      )}
    </>
  );
}
